import React, { useState, useEffect } from "react";
import { db } from "./firebaseconfig";
import { collection, getDocs } from "firebase/firestore";

const cardStyle = {
  border: "1px solid #ddd",
  borderRadius: "8px",
  padding: "16px",
  marginBottom: "16px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  backgroundColor: "#fff",
};

const headerStyle = { marginBottom: "8px", color: "#333" };
const labelStyle = { fontWeight: "600", color: "#555" };
const errorStyle = { color: "red", marginTop: "12px" };

const Orderpage = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "orders"));
        const orderList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOrders(orderList);
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError("Failed to fetch orders. Please try again later.");
      }
    };

    fetchOrders();
  }, []);

  const renderOrderItems = (orderItems) => {
    return orderItems.map((item, idx) => (
      <div key={idx} style={{ marginBottom: "8px", paddingLeft: "8px" }}>
        <div>
          <span style={labelStyle}>Item Name:</span> {item.name}
        </div>
        <div>
          <span style={labelStyle}>Price:</span> ₹{item.price}
        </div>
        <div>
          <span style={labelStyle}>Quantity:</span> {item.quantity}
        </div>
      </div>
    ));
  };

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f7f7f7",
      }}
    >
      <h2 style={{ marginBottom: "16px", color: "#333" }}>All Orders</h2>
      {error && <div style={errorStyle}>{error}</div>}
      {orders.length === 0 && !error && <p>No orders found.</p>}
      {orders.map((order) => (
        <div key={order.id} style={cardStyle}>
          <h3 style={headerStyle}>Order Number: {order.orderNumber}</h3>
          <div>
            <span style={labelStyle}>Appointment Date:</span>{" "}
            {order.appointmentDate}
          </div>
          <div>
            <span style={labelStyle}>Appointment Time:</span>{" "}
            {order.appointmentTime}
          </div>
          <div>
            <span style={labelStyle}>Discount:</span> {order.discount}%
          </div>
          <div>
            <span style={labelStyle}>GST Amount:</span> ₹{order.gstAmount}
          </div>
          <div>
            <span style={labelStyle}>Payment Method:</span>{" "}
            {order.paymentMethod}
          </div>
          <div>
            <span style={labelStyle}>Phone Number:</span> {order.phoneNumber}
          </div>
          <div>
            <span style={labelStyle}>Status:</span> {order.status}
          </div>
          <div>
            <span style={labelStyle}>Salon name:</span>{" "}
            {order.salons && Array.isArray(order.salons)
              ? order.salons.map((salon, index) => <p key={index}>{salon}</p>)
              : "N/A"}
          </div>
          <div style={{ marginTop: "12px" }}>
            <strong>Order Items:</strong>
            {order.orderItems && order.orderItems.length > 0 ? (
              <div>{renderOrderItems(order.orderItems)}</div>
            ) : (
              <div>No Items</div>
            )}
          </div>
          <div style={{ marginTop: "12px" }}>
            <span style={labelStyle}>Total Price:</span> ₹{order.totalPrice}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Orderpage;
